<template lang="pug">
.c-gallery-reader
  div(:class="$style.wrapper")
    div(:class="$style.core")
      b-tooltip(:label="currentItem.description || ''"
        type="is-info"
        size="is-large"
        position="is-bottom"
        multilined)
        div(:class="$style.main"
          v-touch:swipe.left="next"
          v-touch:swipe.right="prev")
          img(:src="currentItem.src")
          div(:class="$style.moleft"
            @click="prev")
            b-icon(pack="fas"
              icon="angle-left")
          div(:class="$style.moright"
            @click="next")
            b-icon(pack="fas"
              icon="angle-right")
      thumb-row(:thumbs="thumbs"
        :current="current"
        @select:thumb="$emit('select:thumb', $event)")
      button(:class="[$style.button, $style.left]"
        @click="prev")
        b-icon(pack="fas"
          icon="angle-left")
      button(:class="[$style.button, $style.right]"
        @click="next")
        b-icon(pack="fas"
          icon="angle-right")
</template>

<script>
import ThumbRow from "@/components/ThumbRow.vue";
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";

export default {
  name: "GalleryReader",
  components: {
    ThumbRow,
    BaseUrlProvider
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    current: {
      type: Number,
      default: null
    }
  },
  computed: {
    thumbs() {
      return this.items.map(item => item.thumbSrc);
    },
    total() {
      return this.items.length;
    },
    currentItem() {
      return this.items[this.current];
    }
  },
  methods: {
    selectThumb(index) {
      this.updateCurrent(index);
    },
    prev() {
      if (this.current > 0) {
        this.updateCurrent(this.current - 1);
      } else {
        this.updateCurrent(this.total - 1);
      }
    },
    next() {
      if (this.current < this.total - 1) {
        this.updateCurrent(this.current + 1);
      } else {
        this.updateCurrent(0);
      }
    },
    updateCurrent(index) {
      this.$emit("update:current", index);
    }
  }
};
</script>

<style module lang="sass">
.wrapper
  +flexbox(center, center, column)

.core
  position: relative
  width: 600px
  max-width: 100%

.main
  width: 100%
  max-height: 60vh
  img
    +size(100%, 100%)
    object-fit: contain

.button
  +size(64px, 64px)
  +abCenter(y)
  +rounded
  +flexbox(center, center)
  +pointer
  background-color: white
  font-size: 36px
  +mobile
    display: none

.left
  left: -100px

.right
  right: -100px

.moleft
  +size(20%, 100%)
  +flexbox(center, center)
  position: absolute
  top: 0
  font-size: 24px
  +tablet
    display: none

.moright
  +size(20%, 100%)
  +flexbox(center, center)
  position: absolute
  top: 0
  right: 0
  font-size: 24px
  +tablet
    display: none
</style>
